import React, { Component } from 'react';
import {NavLink, Link} from "react-router-dom";
import logo from '../Assets/logo.png';
import {name, year} from "../Constant";
import Footer from "../Components/footer";

  class NotFound extends Component{

    constructor(props){
      super(props);
      
      this.state = {
        message: '',
      }
      }
      
      render(){
    return (
        <div className="App">
      <div className="body-wrapper" id="body-wrapper">
      <div className="form-first-child"> </div>

        <div className="form-wrapper">
      <div className="form-wrap">
        <div className="logo-wrap">
          <div className="logo-inner-wrap">
          <NavLink to="/">
            <img className="logo" src={logo} title={name + " Logo"} alt={name + " Logo"}/>
            </NavLink>
          </div>
          </div>
      <div className="form-inner-wrap">
       <h1><span className="text404">404</span><br/>
        <small className="text404small">Page  Not found on {name}.</small> </h1>
       <div className="form-group-lg">    
         <NavLink to="/">
           <button className="btn btn-blue btn-link">GO TO HOME</button>
           </NavLink>
         </div> 
         <div className="form-group-lg">
         <NavLink to="/login">
       <button className="btn btn-pink btn-link">GO TO LOGIN</button>
       </NavLink>
       </div> 
         </div>
        </div>
      </div>
      </div>

      <Footer/>
    </div>
    );
    }
}

export default NotFound;